import React, { useRef, useState } from 'react';
import { Trans, t } from '@lingui/macro';
import clsx from 'clsx';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { SideNavigation } from 'components/Navigation/SideNavigation';
import { useRouterApplicationId } from 'components/Signup/hooks/useRouterApplicationId';
import { NewSignupForm } from 'components/Signup/NewSignupForm/NewSignupForm';
import { NewSignupFormDE } from 'components/Signup/NewSignupFormDE/NewSignupFormDE';
import { SignupForm } from 'components/Signup/SignupForm/SignupForm';
import { StepValidator } from 'components/Signup/StepValidator/StepValidator';
import { useLocale } from 'hooks/useLocale';
import { TImperativeHandleSignup } from 'types';
import styles from './newApplication.module.css';

export const NewApplicationPage = () => {
  const { isUK, isDE } = useLocale();
  const applicationId = useRouterApplicationId();
  const childCompRef = useRef<TImperativeHandleSignup>(null);
  const [saveForLaterDisabled, setSaveForLaterDisabled] = useState(false);
  const [saveForLaterLoading, setSaveForLaterLoading] = useState(false);

  const handleSaveForLater = () => {
    if (!childCompRef.current) return;
    childCompRef.current.saveFormData();
  };

  const DESignupProps = {
    setSaveForLaterDisabled,
    setSaveForLaterLoading,
    ref: childCompRef,
  };

  return (
    <BaseLayout
      pageTitle={
        !applicationId
          ? t`New Application | Introducer Portal`
          : t`Continue Application | Introducer Portal`
      }
      className={styles.applicationLayout}
    >
      <SideNavigation
        hideSideNav={!applicationId && isUK}
        saveForLaterDisabled={saveForLaterDisabled}
        saveForLaterLoading={saveForLaterLoading}
        onSaveForLater={handleSaveForLater}
      />
      <div
        className={clsx(styles.mainContent, {
          [styles.offsetSideNav]: applicationId || isDE,
        })}
      >
        {!applicationId ? (
          <>
            <h1 className={styles.heading}>
              <Trans>Create new application</Trans>
            </h1>
            {isUK ? <NewSignupForm /> : <NewSignupFormDE {...DESignupProps} />}
          </>
        ) : (
          <>
            <h1 className={styles.heading}>
              <Trans>Continue application</Trans>
            </h1>
            <StepValidator>
              {isUK ? (
                <SignupForm
                  setSaveForLaterLoading={setSaveForLaterLoading}
                  ref={childCompRef}
                />
              ) : (
                <NewSignupFormDE {...DESignupProps} />
              )}
            </StepValidator>
          </>
        )}
      </div>
    </BaseLayout>
  );
};
